import { useState } from 'react'
import DrawerModal from 'builder/components/DrawerModal/DrawerModal'
import { TabContentProps } from '../../types'

import { TabItem, TabType, TabLayout } from '../Tabs'
import { TextContent } from '../TextContent/TextContent'
import { LayoutContent } from '../LayoutContent/LayoutContent'
import { TemplatesContent } from '../TemplatesContent/TemplatesContent'

import { Container, TabContainer } from './styles'

type SnapPoint = number | string | null
type Props = TabContentProps & {
  tab: TabType
  isVisible: boolean
  tabItems: TabItem<TabType>[]
  onClose: () => void
  onTabChange: (tab: TabType) => void
}

const snapPoints = ['483px', 1]

export const CustomizeMobileModal = ({
  resume,
  tab,
  tabItems,
  isVisible,
  onTabChange,
  onClose,
}: Props) => {
  const [snapPoint, setSnapPoint] = useState<SnapPoint>(snapPoints[0])

  const Component = {
    text: <TextContent resume={resume} />,
    layout: <LayoutContent resume={resume} />,
    templates: <TemplatesContent resume={resume} />,
  }

  return (
    <DrawerModal
      open={isVisible}
      onClose={onClose}
      snapPoints={snapPoints}
      activeSnapPoint={snapPoint}
      setActiveSnapPoint={setSnapPoint}
    >
      <Container>
        <TabContainer>
          <TabLayout activeTab={tab} items={tabItems} onTabChange={onTabChange} />
        </TabContainer>
        {Component[tab]}
      </Container>
    </DrawerModal>
  )
}
